import { IoChevronBack } from "react-icons/io5";
/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { Post } from '../compornents/Post';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { Analytics } from '../compornents/Analytics';
import axios from 'axios';

export const Profile = () => {
  const navigate = useNavigate();
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [first_furigana, setFirstFurigana] = useState("");
  const [last_furigana, setLastFurigana] = useState("");
  const [zip, setZip] = useState("");
  const [pref, setPref] = useState("");
  const [add1, setAdd1] = useState("");
  const [add2, setAdd2] = useState("");
  const [add3, setAdd3] = useState("");
  const [room, setRoom] = useState("");
  const [addNote, setAddNote] = useState("");
  const [viewSubmitBtn, setViewSubmitBtn] = useState(true);
  // 生年月日（登録済みなら 'YYYY-MM-DD'。未登録なら選択式で1回だけ登録できる）
  const [birthday, setBirthday] = useState("");
  // 性別（任意・4択＋未回答。選んだ瞬間に保存。2026-09-01）
  const [gender, setGender] = useState("");
  const [genderBusy, setGenderBusy] = useState(false);
  const saveGender = async (g) => {
    if (genderBusy) return;
    const prev = gender;
    setGender(g);
    setGenderBusy(true);
    try {
      const res = await Post('post', '/customer/gender.php', { gender: g });
      if (res?.result !== 1) { setGender(prev); toast.error(res?.error_message || '保存に失敗しました'); }
    } catch (e) { setGender(prev); toast.error('通信に失敗しました'); }
    setGenderBusy(false);
  };
  const [bdY, setBdY] = useState("");
  const [bdM, setBdM] = useState("");
  const [bdD, setBdD] = useState("");
  const [bdBusy, setBdBusy] = useState(false);
  const [alreadyOptin, setAlreadyOptin] = useState(true); // 既に配信同意済みならチェック欄を出さない
  const [bdOptin, setBdOptin] = useState(false); // 生年月日登録と同時の配信同意（任意・既定OFF）
  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });
  const handleBlur = (e) => {
    if (first_name !== '' &&
      last_name !== '' &&
      first_furigana !== '' &&
      last_furigana !== '' &&
      zip !== '' &&
      pref !== '' &&
      add1 !== '' &&
      add2 !== '') {
      setViewSubmitBtn(true);
    } else {
      setViewSubmitBtn(false);
    }
  }
  // 顧客更新
  async function updateCustomer() {
    openLoadingModal();
    // console.log('update');
    // 見積もり取得
    const request_data = {
      first_name:first_name,
      last_name:last_name,
      first_furigana:first_furigana,
      last_furigana:last_furigana,
      zip:zip,
      pref:pref,
      add1:add1,
      add2: add2,
      add3: add3,
      room: room,
      add_note: addNote,
     };
    const response_data = await Post('post', '/customer/update.php', request_data);
    // console.log(response_data);
    if (response_data.result === 1) {
      // navigate("/account");
      navigate("/location2", { state: { customer: response_data.customer } });
    } else {
      // エラー
      toast.error(response_data.error_message);
    }
    closeLoadingModal();
  };
  // 西暦→和暦表記（年プルダウンの併記用。データは西暦のまま保存する）
  const wareki = (y) => {
    if (y >= 2019) return y === 2019 ? '令和元' : `令和${y - 2018}`;
    if (y >= 1989) return y === 1989 ? '平成元' : `平成${y - 1988}`;
    if (y >= 1926) return y === 1926 ? '昭和元' : `昭和${y - 1925}`;
    if (y >= 1912) return y === 1912 ? '大正元' : `大正${y - 1911}`;
    return `明治${y - 1867}`;
  };

  // 生年月日の登録（1回のみ・登録で500円クーポン付与）
  async function registerBirthday() {
    if (!bdY || !bdM || !bdD) {
      toast.error('生年月日を選択してください');
      return;
    }
    setBdBusy(true);
    openLoadingModal();
    const bd = `${bdY}-${String(bdM).padStart(2, '0')}-${String(bdD).padStart(2, '0')}`;
    const response_data = await Post('post', '/customer/birthday.php', { birthday: bd });
    if (response_data.result === 1) {
      setBirthday(bd);
      // 配信同意（任意チェック）を保存。失敗しても登録は継続。
      if (bdOptin && !alreadyOptin) {
        Post('post', '/customer/set_flag.php', { type: 'is_marketing_optin', value: 1 }).catch(() => {});
        setAlreadyOptin(true);
      }
      if (response_data.coupon) {
        toast.success(`ご登録ありがとうございます！${response_data.coupon.kingaku}円クーポンをプレゼントしました🎁`);
      } else {
        toast.success('生年月日を登録しました');
      }
    } else {
      toast.error(response_data.error_message || '登録に失敗しました');
    }
    closeLoadingModal();
    setBdBusy(false);
  }

  // 郵便番号から住所取得
  const fetchAddress = async (zip) => {
    if (zip.length === 7) {
      try {
        const response = await axios.get(
          `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip}`
        );
        const data = response.data;
        if (data.results) {
          const result = data.results[0];
          setPref(`${result.address1}`);
          setAdd1(`${result.address2}${result.address3}`);
        } else {
          // setAddress("住所が見つかりません");
        }
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    }
  };

  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    let unmounted = false;
    // 顧客情報取得
    (async () => {
      openLoadingModal();
      const request_data = {}
      // post
      const response_data = await Post('post', '/customer/index.php', request_data);
      // 結果
      // console.log(response_data);
      if (response_data.result === 1) {

        const first_name = response_data.customer.first_name;
        const last_name = response_data.customer.last_name;
        const first_furigana = response_data.customer.first_furigana;
        const last_furigana = response_data.customer.last_furigana;
        const zip = response_data.customer.zip;
        const pref = response_data.customer.pref;
        const add1 = response_data.customer.add1;
        const add2 = response_data.customer.add2;
        const add3 = response_data.customer.add3;
        const room = response_data.customer.room;
        const add_note = response_data.customer.add_note;
        if (!unmounted){
          setFirstName(first_name);
          setLastName(last_name);
          setFirstFurigana(first_furigana);
          setLastFurigana(last_furigana);
          setZip(zip);
          setPref(pref);
          setAdd1(add1);
          setAdd2(add2);
          setAdd3(add3);
          setRoom(room);
          setAddNote(add_note);
          setBirthday(response_data.customer.birthday || "");
          setGender(response_data.customer.gender || "");
          setAlreadyOptin(Number(response_data.customer.is_marketing_optin) === 1);
          if (first_name !== '' &&
            last_name !== '' &&
            first_furigana !== '' &&
            last_furigana !== '' &&
            zip !== '' &&
            pref !== '' &&
            add1 !== '' &&
            add2 !== '') {
            setViewSubmitBtn(true);
          } else {
            setViewSubmitBtn(false);
          }
        }
      } else {
        // エラー
        toast.error(response_data.error_message);
      }
      closeLoadingModal();
    })();

    //クリーンアップ関数を返す
    return () => { unmounted = true; };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  // 戻る
  const back = () => {
    navigate(-1);
  };
  return (
    <div className="App">
      <div className="Profile">
        <Analytics title="個人情報" />
        <div className="toolbar mb-3">
          <div className="toolbar_left div_btn" onClick={back} >
            <IoChevronBack />
          </div>
          <div className="toolbar_center">
            個人情報
          </div>
          <div className="toolbar_right">
          </div>
        </div>
        <div className="m-4">
          <div className="mb-4">
            <div className="mb-3">
              <div className="mb-2">
                お名前（漢字）
                <span className="text-danger">＊</span>
              </div>
              <div className="row">
                <div className="col-6">
                  <input type="text" className="form-control" placeholder="例）山田" value={first_name}
                    onChange={e => setFirstName(e.target.value)} onBlur={handleBlur} />
                </div>
                <div className="col-6">
                  <input type="text" className="form-control" placeholder="花子" value={last_name} onChange={e => setLastName(e.target.value)} onBlur={handleBlur} />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="mb-2">
                お名前（ふりがな）
                <span className="text-danger">＊</span>
              </div>
              <div className="row">
                <div className="col-6">
                  <input type="text" className="form-control" placeholder="例）やまだ" value={first_furigana} onChange={e => setFirstFurigana(e.target.value)} onBlur={handleBlur} />
                </div>
                <div className="col-6">
                  <input type="text" className="form-control" placeholder="はなこ" value={last_furigana} onChange={e => setLastFurigana(e.target.value)} onBlur={handleBlur} />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="mb-2">
                郵便番号
                <span className="text-danger">＊</span>
              </div>
              <div className="row">
                <div className="col-12">
                  <input type="text" className="form-control" placeholder="例）8001234" value={zip} onChange={e => {fetchAddress(e.target.value);setZip(e.target.value);}} onBlur={handleBlur} />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="mb-2">
                都道府県
                <span className="text-danger">＊</span>
              </div>
              <div className="row">
                <div className="col-12">
                  <input type="text" className="form-control" placeholder="例）福岡県" value={pref} onChange={e => setPref(e.target.value)} onBlur={handleBlur} />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="mb-2">
                市区町村
                <span className="text-danger">＊</span>
              </div>
              <div className="row">
                <div className="col-12">
                  <input type="text" className="form-control" placeholder="例）福岡市中央区天神" value={add1} onChange={e => setAdd1(e.target.value)} onBlur={handleBlur} />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="mb-2">
                丁目または番地
                <span className="text-danger">＊</span>
              </div>
              <div className="row">
                <div className="col-12">
                  <input type="text" className="form-control" placeholder="例）1-1" value={add2} onChange={e => setAdd2(e.target.value)} onBlur={handleBlur} />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="mb-2">
                建物名
              </div>
              <div className="row">
                <div className="col-12">
                  <input type="text" className="form-control" placeholder="例）ランドリーマンション" value={add3} onChange={e => setAdd3(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="mb-2">
                部屋番号
              </div>
              <div className="row">
                <div className="col-12">
                  <input type="text" className="form-control" placeholder="例）１０１" value={room} onChange={e => setRoom(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="mb-2">
                住所の詳細
              </div>
              <div className="row">
                <div className="col-12">
                  <textarea type="text" className="form-control" placeholder="例）一戸建、表札あり、建物の外観" value={addNote} onChange={e => setAddNote(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="mb-2">
                生年月日
              </div>
              {birthday ? (
                <div>
                  <div className="row">
                    <div className="col-12">
                      <input type="text" className="form-control" value={birthday.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$1年$2月$3日')} readOnly disabled />
                    </div>
                  </div>
                  <div className="text-left mt-1" style={{ fontSize: 12, color: '#888' }}>
                    ※ご登録済みです。お誕生月に毎年1,000円クーポンをお届けします🎂
                  </div>
                </div>
              ) : (
                <div>
                  <div style={{ background: '#fdf2f8', border: '1px solid #f9a8d4', borderRadius: 10, padding: '10px 12px', fontSize: 13, color: '#9d174d', textAlign: 'left', marginBottom: 8 }}>
                    🎂 ご登録で<b>500円クーポン</b>をその場でプレゼント！お誕生月には毎年<b>1,000円クーポン</b>をお届けします
                  </div>
                  <div className="row">
                    <div className="col-5">
                      <select className="form-control" value={bdY} onChange={e => setBdY(e.target.value)}>
                        <option value="">年</option>
                        {Array.from({ length: 90 }, (_, i) => new Date().getFullYear() - 15 - i).map((y) => (
                          <option key={y} value={y}>{y}年（{wareki(y)}）</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-3" style={{ paddingLeft: 4, paddingRight: 4 }}>
                      <select className="form-control" value={bdM} onChange={e => setBdM(e.target.value)}>
                        <option value="">月</option>
                        {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                          <option key={m} value={m}>{m}月</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-4">
                      <select className="form-control" value={bdD} onChange={e => setBdD(e.target.value)}>
                        <option value="">日</option>
                        {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => (
                          <option key={d} value={d}>{d}日</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {!alreadyOptin && (
                    <label className="text-left mt-2" style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 0, cursor: 'pointer' }}>
                      <input type="checkbox" checked={bdOptin} onChange={(e) => setBdOptin(e.target.checked)} style={{ marginTop: 3 }} />
                      <span style={{ fontSize: 12, color: '#555' }}>🎁 クーポン・キャンペーン等のお得情報の配信を受け取る（任意・いつでも停止できます）</span>
                    </label>
                  )}
                  <div className="mt-2">
                    <button className="btn btn-oval btn-yellow form-control" style={{ textAlign: 'center', paddingLeft: 8, paddingRight: 8, whiteSpace: 'normal' }} disabled={bdBusy} onClick={() => registerBirthday()}>
                      生年月日を登録してクーポンをもらう
                    </button>
                  </div>
                  <div className="text-left mt-1" style={{ fontSize: 12, color: '#888' }}>
                    ※登録後の変更はできません
                  </div>
                </div>
              )}
            </div>
            <div className="mb-3">
              <div className="mb-2">
                性別<span style={{ fontSize: 12, color: '#888' }}>（任意）</span>
              </div>
              <div className="row" style={{ marginLeft: -4, marginRight: -4 }}>
                {[['female', '女性'], ['male', '男性'], ['other', 'その他'], ['no_answer', '回答しない']].map(([v, label]) => (
                  <div className="col-3" key={v} style={{ paddingLeft: 4, paddingRight: 4 }}>
                    <button
                      type="button"
                      className="form-control"
                      disabled={genderBusy}
                      onClick={() => saveGender(gender === v ? '' : v)}
                      style={{
                        fontSize: 13, padding: '8px 2px', borderRadius: 8, cursor: 'pointer',
                        border: gender === v ? '2px solid #d4a900' : '1px solid #ced4da',
                        background: gender === v ? '#F8E100' : '#fff',
                        fontWeight: gender === v ? 700 : 400,
                      }}
                    >
                      {label}
                    </button>
                  </div>
                ))}
              </div>
              <div className="text-left mt-1" style={{ fontSize: 12, color: '#888' }}>
                ※サービス改善・統計のために使用します。選び直し・取り消し（再タップ）はいつでもできます
              </div>
            </div>
          </div>
          {viewSubmitBtn === true ? (
            <div className="mb-2">
              <button className="btn btn-oval btn-yellow form-control" onClick={() => updateCustomer()}>変更する</button>
            </div>
          ) : (
            <div className="mb-2">
              <button className="btn btn-oval btn-gray-dark form-control">変更する</button>
            </div>
          )}
        </div>
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div >
              <TailSpin stroke="#000" />
            </div>
            <div className="">
              <div className="">
                処理中です
              </div>
            </div>
          </div>
        </LoadingModal>
        <Tabbar menu="account" />
      </div>

    </div>
  );
}
